import React from 'react';
import {
  Box,
  Button,
  CustomSelect,
  MUIDataTableColumn,
  TableActionTypes,
  TableState,
  Typography,
  MUIDataTableMeta,
} from 'web-library';
import { customFilterChipRender } from '../../../../hooks/table';
import { stringToSemanticDisplay } from '../../../../utils/DateUtils';
import { SelectChangeEvent } from '@mui/material';

/** MUI Data Table Columns
 * */
export const candidateTypeColumn = (
  classes: any,
  tableDispatch: React.Dispatch<TableActionTypes>,
  filterMappingCandidateType: any,
  state: TableState,
  filterCodeCandidateType: any
): MUIDataTableColumn => ({
  name: 'candidateType',
  label: 'Candidate Type',
  options: {
    sort: false,
    filter: true,
    filterType: 'custom',
    filterList:
      state.filters.candidateType && state.filters.candidateType.length
        ? state.filters.candidateType
        : undefined,
    // chip logic
    customFilterListOptions: {
      render: (v:any) => [filterMappingCandidateType[v[0]].children],
      update: (filterList: string[][],
              filterPos: number,
              index: number) => {
        // update table filter state
        tableDispatch({
          type: 'UPDATE_FILTERS',
          payload: { ...state.filters, candidateType: [] },
        });

        // update table inner filter
        return customFilterChipRender(filterList, filterPos, index);
      },
    },
    filterOptions: {
      fullWidth: true,
      display: (filterList: string[][], onChange: (val: string | string[], index: number, column: MUIDataTableColumn) => void, index: number, column: MUIDataTableColumn) => (
        <CustomSelect
          className={classes.select}
          // eslint-disable-next-line react/destructuring-assignment
          value={filterList[index][0]}
          displayEmpty
          menuItems={filterCodeCandidateType}
          onChange={(event) => {
            // eslint-disable-next-line no-param-reassign
            filterList[index][0] = event.target.value as string;
            onChange(filterList[index], index, column);
          }}
          label="Candidate Type"
          labelId="inputSelectLabel-candidateType"
          id="inputSelect-candidateType"
        />
      ),
    },
  },
});

export const examLevelColumn = (
  classes: any,
  tableDispatch: React.Dispatch<TableActionTypes>,
  filterMappingExamLevel: any,
  state: TableState,
  filterCodeExamLevel: any
): MUIDataTableColumn => ({
  name: 'examLevel',
  label: 'Exam Level',
  options: {
    sort: false,
    filter: true,
    filterType: 'custom',
    filterList:
      state.filters.examLevel && state.filters.examLevel.length
        ? state.filters.examLevel
        : undefined,
    customFilterListOptions: {
      render: (v:any) => [filterMappingExamLevel[v[0]].children],
      update: (filterList: string[][],
              filterPos: number,
              index: number) => {
        // update table filter state
        tableDispatch({
          type: 'UPDATE_FILTERS',
          payload: { ...state.filters, examLevel: [] },
        });

        // update table inner filter
        return customFilterChipRender(filterList, filterPos, index);
      },
    },
    filterOptions: {
      fullWidth: true,
      display: (filterList: string[][], onChange: (val: string | string[], index: number, column: MUIDataTableColumn) => void, index: number, column: MUIDataTableColumn) => (
        <CustomSelect
          className={classes.select}
          // eslint-disable-next-line react/destructuring-assignment
          value={filterList[index][0]}
          displayEmpty
          menuItems={filterCodeExamLevel}
          onChange={(event) => {
            // eslint-disable-next-line no-param-reassign
            filterList[index][0] = event.target.value as string;
            onChange(filterList[index], index, column);
          }}
          label="Exam Level"
          labelId="inputSelectLabel-examLevel"
          id="inputSelect-examLevel"
        />
      ),
    },
  },
});

export const paymentModeColumn = (
  classes: any,
  tableDispatch: React.Dispatch<TableActionTypes>,
  filterMappingPaymentMode: any,
  state: TableState,
  filterCodePaymentMode: any
): MUIDataTableColumn => ({
  name: 'paymentMode',
  label: 'Payment Mode',
  options: {
    sort: false,
    filter: true,
    filterType: 'custom',
    filterList:
      state.filters.paymentMode !== undefined && state.filters.paymentMode.length
        ? state.filters.paymentMode
        : undefined,
    // chip logic
    customFilterListOptions: {
      render: (v:any) => {
        if (v.length > 1) {
          return [`${filterMappingPaymentMode[v[0]].children}, ..`];
        }
        if (v.length === 1) {
          return [filterMappingPaymentMode[v[0]].children];
        }
        return [];
      },
      update: (filterList: string[][],
              filterPos: number,
              index: number) => {
        // update table filter state
        tableDispatch({
          type: 'UPDATE_FILTERS',
          payload: { ...state.filters, paymentMode: [] },
        });

        // update table inner filter
        return customFilterChipRender(filterList, filterPos, index);
      },
    },
    filterOptions: {
      fullWidth: true,
      display: (filterList: string[][], onChange: (val: string | string[], index: number, column: MUIDataTableColumn) => void, index: number, column: MUIDataTableColumn) => (
        <CustomSelect
          className={classes.select}
          displayEmpty
          variant="filled"
          multiple
          // eslint-disable-next-line no-param-reassign,react/destructuring-assignment
          value={filterList[index]}
          menuItems={filterCodePaymentMode}
         onChange={(e: SelectChangeEvent<unknown>) => {
            // eslint-disable-next-line no-param-reassign
            filterList[index] = e.target.value as string[];
            onChange(filterList[index], index, column);
            window.dispatchEvent(new CustomEvent('resize'));
          }}
          label="Payment Mode"
          labelId="inputSelectLabel-paymentMode"
          id="inputSelect-paymentMode"
          renderValue={(selected: unknown | string[]) =>
            Array.isArray(selected) && selected.length > 0
              ? // @ts-ignore
                filterCodePaymentMode
                  .filter((paymentMode: any) => selected.includes(paymentMode.value))
                  .map((s: any) => s.children)
                  .join(', ')
              : 'Select payment mode'
          }
        />
      ),
    },
  },
});

export const applicationDateColumn = (): MUIDataTableColumn => ({
  name: 'applicationDate',
  label: 'Application Date',
  options: {
    customBodyRender: (value: any, tableMeta: MUIDataTableMeta, updateValue: (value: any) => void)  => (
      <Typography variant="body1">{stringToSemanticDisplay(value)}</Typography>
    ),
    sort: true,
    filter: false,
  },
});

export const appealFeeColumn = (
  classes: any,
  state: TableState,
  translation: {
    appealFeeLabel: string;
    inclusiveGstLabel: string;
  }
): MUIDataTableColumn => ({
  name: 'appealFee',
  options: {
    customHeadLabelRender: () => (
      <Typography variant="h6" style={{ textAlign: 'right' }}>
        {translation.appealFeeLabel}
        <br />
        {translation.inclusiveGstLabel}
      </Typography>
    ),
    customBodyRenderLite: (dataIndex: number, rowIndex: number) => (
      <Box className={classes.feeCell}>
        <Typography id={`text-examFees-row${rowIndex}`} variant="body1">
          S${state.data[dataIndex].appealFee}
        </Typography>
      </Box>
    ),
    searchable: false,
    sort: false,
    filter: false,
  },
});

export const actionColumn = (
  classes: any,
  onViewDetails: (uuid: string) => void,
  name: string,
  translations: {
    label: string;
    viewDetailsLabel: string;
  }
): MUIDataTableColumn => ({
  name,
  label: translations.label,
  options: {
    customBodyRender: (value: any, tableMeta: MUIDataTableMeta, updateValue: (value: any) => void)  => (
      <Button
        color="primary"
        className={classes.viewDetailsButton}
        variant="text"
        onClick={() => {
          onViewDetails(tableMeta.rowData[8]);
        }}
        size="small"
      >
        {translations.viewDetailsLabel}
      </Button>
    ),
    sort: false,
    filter: false,
  },
});
